import { createDefaultFormatters, createStandardConfig } from './utils'
import { DeliveryInfo } from 'src/apollo/onlineOrdering'

/**
 * US Address Configuration
 */
export const US_CONFIG = createStandardConfig({
  countryCode: 'US',
  countryName: 'United States',
  requiresStreetNumber: true,
  formatters: {
    formatLine1: (address: DeliveryInfo, includeAddress2 = true) => {
      if (!address) return ''

      if (!includeAddress2 || !address?.address2) {
        return address.address1
      }

      // Check if address2 already contains descriptive text (suite, apt, unit, etc.)
      const hasDescriptiveText = /^(suite|apt|apartment|unit|ste|#)/i.test(
        address.address2.trim()
      )

      // If it already has descriptive text, use as-is; otherwise add # prefix
      const formattedAddress2 = hasDescriptiveText
        ? address.address2
        : `#${address.address2}`

      return `${address.address1}, ${formattedAddress2}`
    },
    formatLine2: createDefaultFormatters().formatLine2
  },
  fieldOverrides: {
    city: {
      // locality should be given priority, so always overwrite other data that may have been put in the city.
      // https://developers.google.com/maps/documentation/javascript/examples/places-autocomplete-addressform
      // Brooklyn and other parts of New York City do not include the city as part of the address. Instead, they use sublocality_level_1.
      // Based on querying the Toast Local database, some Rxs dont have a locality or sublocality_level_1, but do have a city in the
      // administrative_area_level_3 field.
      googleTypes: [
        'locality',
        'neighborhood',
        'sublocality_level_1',
        'administrative_area_level_3',
        'postal_town'
      ]
    }
  }
})
